import { render, staticRenderFns } from "./PaymentImage.vue?vue&type=template&id=4f03b6e6&scoped=true&"
import script from "./PaymentImage.vue?vue&type=script&lang=js&"
export * from "./PaymentImage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentImage.vue?vue&type=style&index=0&id=4f03b6e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03b6e6",
  null
  
)

export default component.exports